import SettingsPage from "./SettingsPage";
import useListTimelineMonths from "./useListTimelineMonths";

export default SettingsPage;

export {
    useListTimelineMonths,
}